
import { Auth, sales, special, shop, healthy, order, live, chat, expert } from './path'
import { requestControl } from './requestControl'

// 省
export function province(data) { return requestControl(Auth.province, data) }
// 市
export function city(data) { return requestControl(Auth.city, data) }
// 获取验证码
export function sendCode(data) { return requestControl(Auth.sendCode, data) }
// 获取加密的验证码
export function vtSendCode(data) { return requestControl(Auth.vtSendCode, data) }
// 注册
export function register(data) { return requestControl(Auth.register, data) }
// 微信分享
export function wxShare(data) { return requestControl(Auth.wxShare, data) }

// 普通商品详情页接口
export function shopGeneral(data) { return requestControl(shop.shopGeneral, data) }
// 品牌闪购商品详情页
export function shopLimitBuy(data) { return requestControl(shop.shopLimitBuy, data) }
// 新品首发商品详情页
export function shopNewGoods(data) { return requestControl(shop.shopNewGoods, data) }
// 秒杀商品详情页
export function shopSeckill(data) { return requestControl(shop.shopSeckill, data) }
// 联免组合详情页
export function shopCombination(data) { return requestControl(shop.shopCombination, data) }
// 优惠券接口
export function shopEnable(data) { return requestControl(shop.shopEnable, data) }

// 产品详情2
export function countReport(data) { return requestControl(sales.countReport, data) }
// 产品详情3
export function getOrganizeTree(data) { return requestControl(sales.getOrganizeTree, data) }

// 普莱柯专场
export function specialList(data) { return requestControl(special.specialList, data) }


// 健康管理商品猪阶段
export function GetStageReport(data) { return requestControl(healthy.GetStageReport, data) }
// 健康管理商品猪周期
export function GetWholeReport(data) { return requestControl(healthy.GetWholeReport, data) }
// 健康管理种猪获取单个档案的阶段报告
export function GetBreedingReport(data) { return requestControl(healthy.GetBreedingReport, data) }
// 健康管理种猪获取胎次报告
export function GeBreedingRotateReport(data) { return requestControl(healthy.GeBreedingRotateReport, data) }
// 健康管理种猪报告添加头数
export function AddBpNumOfReport(data) { return requestControl(healthy.AddBpNumOfReport, data) }

// 好兽药订单详情
export function orderDetail(data) { return requestControl(order.orderDetail, data) }
// 莱客云个人统计
export function CountPersonalReport(data) { return requestControl(sales.CountPersonalReport, data) }
// 莱客云个人统计 获取用户信息
export function getUserInfo(data) { return requestControl(sales.getUserInfo, data) }

// 直播接口
export function liveDetail(data) { return requestControl(live.liveDetail, data) }
// 直播断流接口
export function liveStatus(data) { return requestControl(live.liveStatus, data) }

// 聊天室登陆接口
export function cusLogin(data) { return requestControl(chat.cusLogin, data) }
// 聊天室登陆接口
export function UserInfo(data) { return requestControl(chat.UserInfo, data) }
// 聊天室融云接口
export function getRongToken(data) { return requestControl(chat.getRongToken, data) }

// 专家组方 组方详情
export function compreDetail(data) { return requestControl(expert.compreDetail, data) }
// 专家组方 专享详情页
export function expertinfo(data) { return requestControl(expert.expertinfo, data) }
// 专家详情
export function getExpertDetail(data) { return requestControl(expert.getExpertDetail, data) }

// 店铺详情
export function findStoreByOrganId(data) { return requestControl(shop.findStoreByOrganId, data) }